import { Box, Button, Stack } from '@mui/material';
import {
  getAgreementTermById,
  getAllAgreementTermsByInstitution,
} from 'api/agreement-term/agreement-term.api';
import { ListAgreementTermResponse } from 'api/agreement-term/api.types';
import ContainerPainel from 'components/container_painel';
import { Loading } from 'components/login';
import DataConfirmation from 'components/shared/data_confirmation';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { formatDate } from 'utils/format_date';

interface LocationState {
  state?: ListAgreementTermResponse;
}

const ViewTermsAdhesion: React.FC = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();

  const [term, setTerm] = useState<any | null>(null);
  const [terms, setTerms] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const getTerm = async () => {
    const response = await getAgreementTermById(uuid!);

    if (!response) {
      setIsLoading(false);
      return;
    }
    await getAllTerms(response?.institution?.uuid);
    setTerm(response!);
    setIsLoading(false);
  };

  useEffect(() => {
    getTerm();
  }, []);

  const getAllTerms = async (institutionUuid: string) => {
    const response = await getAllAgreementTermsByInstitution(institutionUuid);
    setTerms(response);
    return response;
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <ContainerPainel
          pagina='Termo de Adesão Municipal'
          showBackButton
          backButtonPath='/termo-de-adesao'
        >
          <Stack marginX='4rem' spacing='2rem'>
            <DataConfirmation
              title='Dados do Termo de Adesão'
              data={[
                {
                  label: 'Prefeitura',
                  value: term?.institution?.name,
                },
                {
                  label: 'Data do Vencimento',
                  value: formatDate(term?.dueAt),
                },
                {
                  label: 'Data da Assinatura - Representante Legal Municipal',
                  value: term?.municipalSignatureDate,
                },
                {
                  label: 'Data da Assinatura - Representante Legal Estadual',
                  value: term?.stateSignatureDate,
                },
                {
                  label: 'Status',
                  value: term?.status,
                },
              ]}
            />
            <DataConfirmation
              title='Termo de Adesão Vigente'
              atas={[
                {
                  titlePDF: 'Arquivo Enviado',
                  label: term?.file?.name,
                  fileName: term?.file?.mimeType,
                  fileSize: term?.file?.size,
                  base64: term?.file?.base64,
                  onView: () => console.log('Visualizar documento'),
                },
              ]}
            />
            {terms && (
              <DataConfirmation
                title='Histórico Termos de Adesão'
                historyTerms={terms}
                showHistoryTerms={true}
              />
            )}
          </Stack>

          {/* Botões */}
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            gap={2}
            marginTop='20px'
          >
            <Button
              variant='text'
              sx={{
                color: '#1976D2',
                fontWeight: 'bold',
                textTransform: 'uppercase',
              }}
              onClick={() => navigate('/termo-de-adesao')}
            >
              Voltar
            </Button>
          </Box>
        </ContainerPainel>
      )}
    </>
  );
};

export default ViewTermsAdhesion;
